import React from 'react';
import { useIntl } from 'react-intl';
import messages from './FieldMessages';
import RenderProperty from './RenderProperty';

const NaceCodeChange = props => {
  const intl = useIntl();
  const { log } = props;

  if (log.oldValue === null) {
    return (
      <span>
        {intl.formatMessage(messages.AddedNaceCode, {
          property: RenderProperty({ intl, log }),
          code: log.newValue,
          b: value => <b>{value}</b>,
        })}
      </span>
    );
  }

  return (
    <span>
      {intl.formatMessage(messages.DeletedNaceCode, {
        property: RenderProperty({ intl, log }),
        code: log.oldValue,
        b: value => <b>{value}</b>,
      })}
    </span>
  );
};

export default NaceCodeChange;
